<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<div class="row m-0 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">

								<div class="row">
									<div class="col-sm-1"></div>
									<div class="col-sm-10">
									    <h5>メッセージ詳細</h5>
										<hr>
									</div>
									<div class="col-sm-1"></div>
								</div>

								<div class="row">
									<div class="col-sm-1"></div>
									<div class="col-sm-10 main">
										<div class="card my-3">
											<div class="card-body p-4">
												<div>
											        <div v-for="(message_detail, index) in allMessages">
														<template v-if="you != null && message_detail['users_id'] == you['id']">
															<p v-if="you['user_type'] == 1 || you['user_type'] == 2 || you['user_type'] == 3" class="text-left m-0">
															  <span style="font-size: 0.8rem;" v-if="you['user_type'] == 2">
																<strong v-if="you['legal_person']==1">{{ cinit(you['corp_name'], '-') }}</strong>
																<strong v-else-if="you['legal_person']==0">{{ cinit(you['store_name'], '-') }}</strong>
															  </span>
															  <span style="font-size: 0.8rem;">{{ getUserName(you) }}</span>
															</p>
															<p class="text-left m-0">
															  <span style="padding: 8px;background-color: #dff0ff;border-radius: 8px;border: solid 1px #a3a1a1;min-width: 200px;display: inline-block;white-space: pre-wrap;">{{ message_detail['contents'] }}</span>
															</p>
															<p style="font-size: 0.8rem;" class="text-left">{{ convert_jst_for_message(message_detail['created_at']) }}</p>
														</template>
														<template v-if="message_detail['users_id'] == i['id']">
															<p v-if="i['user_type'] == 1 || i['user_type'] == 2 || i['user_type'] == 3" class="text-right m-0">
															  <span style="font-size: 0.8rem;" v-if="i['user_type'] == 2">
																<strong v-if="i['legal_person']==1">{{ cinit(i['corp_name'], '-') }}</strong>
																<strong v-else-if="i['legal_person']==0">{{ cinit(i['store_name'], '-') }}</strong>
															  </span>
															  <span style="font-size: 0.8rem;">{{ getUserName(i) }}</span>
															</p>
															<p class="text-right m-0">
															  <span style="padding: 8px;background-color: #f0f0f0;border-radius: 8px;border: solid 1px #a3a1a1;min-width: 200px;display: inline-block;white-space: pre-wrap;">{{ message_detail['contents'] }}</span>
															</p>
															<p style="font-size: 0.8rem;" class="text-right">{{ convert_jst_for_message(message_detail['created_at']) }}</p>
														</template>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-1"></div>
								</div>

							</div>
						</div>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'AdminMessage',
	data () {
		return {
			// パラメータ
			users_id: null,
			status: null,
			messages_id: null,

			i: null,
			you: null,

			sendForm: {
				contents: "",
				messages_id: "",
				users_id_1: "",
				users_id_2: "",
				status: "",
			},

			messages: null,
			message_details: [],
		}
	},
	methods: {
	  // this.$route.params.users_id
	  async get_message_detail() {
		this.$store.dispatch('message/get_message_detail_admin', {
          users_id: this.users_id,
          status: this.status,
          messages_id: this.messages_id,
        }).then(res => {
		  console.log(res);
		  let ret = res.data.message_details;
		  this.message_details = ret['message_details'];
		  this.messages = ret['messages'];
		  this.i = ret['i'];
		  this.you = ret['you'];
		  if ( this.messages == null ) {
			this.sendForm.users_id_1 = this.i['id'];
			this.sendForm.users_id_2 = this.users_id;
			this.sendForm.messages_id = this.messages_id;
			this.sendForm.status = this.status;
		  } else {
			this.sendForm.users_id_1 = this.messages['users_id_1'];
			this.sendForm.users_id_2 = this.messages['users_id_2'];
			this.sendForm.messages_id = this.messages['id'];
			this.sendForm.status = this.messages['status'];
		  }
		  this.$nextTick(function() {
			document.getElementById("jump_comment").scrollIntoView(false)
		  });
		  console.log(this.message_details);
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },

	//   jumpDetail: function(id){
    //     this.$router.push({path: '/product/'+String(id)});
	//   },

	},
	created() {
		this.users_id = this.$route.params.users_id;
		this.status = this.$route.params.status;
		this.messages_id = this.$route.params.messages_id;
		this.get_message_detail();
	},
	computed: {
		allMessages: function() {
			return this.message_details;
		},
	},
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/AdminMessage.vue